import React, {FC} from 'react';
import styled from 'styled-components';

import StatisticsTrend from '../StatisticsTrend';
import {Formatter} from '../../../types';

interface ColoursMap<T> {
    inactive: T;
    selected: T;
}

function getMappedColours<T = any>(isSelected: boolean, map: ColoursMap<T>): T {
    return isSelected ? map.selected : map.inactive;
}

const TrendWrapper = styled.span<{
    value: number | string;
    isSelected: boolean;
}>`
    margin: ${p => p.theme.muiTheme.spacing(0, 1, 0, 0)};
    color: ${p =>
        p.value
            ? p.theme.muiTheme.palette.primary.light
            : getMappedColours<string>(p.isSelected, {
                  selected: p.theme.muiTheme.palette.warning.main,
                  inactive: p.theme.muiTheme.palette.dividerStrong
              })};
    & > span {
        margin: 0;
    }
`;

export interface TrendProps {
    value: number | string;
    valueType?: string;
    isSelected?: boolean;
    formatter: Formatter<undefined>;
}

const MyTopPerformingGamesTrend: FC<TrendProps> = ({
    value,
    valueType,
    isSelected,
    formatter
}: TrendProps) => (
    <TrendWrapper value={value} isSelected={isSelected}>
        {!!value && valueType && `${valueType} `}
        <StatisticsTrend value={formatter(value)} isSelected={isSelected} />
    </TrendWrapper>
);

export default MyTopPerformingGamesTrend;
